module.exports = __webpack_public_path__ + "static/media/1244_EduPrompts.20484b14.png";